export interface Character {
  id: string;
  name: string;
  nameJp: string;
  title: string;
  description: string;
  image: string;
  count: number;
  accent: string;
}

export const characters: Character[] = [
  {
    id: "hinata",
    name: "日向雏田",
    nameJp: "日向ヒナタ",
    title: "温柔系女主 · 白瞳忍者",
    description:
      "木叶日向一族的公主，性格内向温柔却又坚韧不拔。作为火影忍者同人中最受欢迎的女主角之一，日向雏田同人涵盖校园日常、告白剧情与成长蜕变等多种题材，人气常年居高不下。",
    image:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_shy_gentle_ninja_girl_with_long_dark_indigo_blue_hair_and_pale_lavender_eyes_wearing_a_white_and_indigo_lightweight_jacket_sporty_fighting_outfit_calm_warm_expression_soft_warm_cream_toned_background_with_subtle_sakura_petals_clean_flat_color_anime_style_portrait_high_quality&width=420&height=540&seq=naruto-hinata-2026&orientation=portrait",
    count: 328,
    accent: "primary",
  },
  {
    id: "sakura",
    name: "春野樱",
    nameJp: "春野サクラ",
    title: "坚韧女主角 · 医疗忍者",
    description:
      "粉发少女，从依赖同伴到独当一面的医疗忍者。春野樱同人常聚焦她的成长弧线、师徒羁绊与爱情故事，既有轻松搞笑的日常，也有热血感人的战斗剧情。",
    image:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_confident_ninja_girl_with_pink_short_hair_and_green_eyes_wearing_red_black_combat_sportswear_and_forehead_protector_energetic_hopeful_expression_soft_warm_cream_toned_background_with_sakura_petals_clean_flat_color_anime_style_portrait_high_quality&width=420&height=540&seq=naruto-sakura-2026&orientation=portrait",
    count: 296,
    accent: "accent",
  },
  {
    id: "tsunade",
    name: "纲手",
    nameJp: "綱手",
    title: "三忍之一 · 五代火影",
    description:
      "传说中的三忍之一，精通医疗忍术的初代火影孙女。纲手同人融合成熟御姐气质与火影担当，题材涵盖医忍传说、战争回忆与全新冒险，塑造出极具魅力的传奇角色。",
    image:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_legendary_mature_blonde_ninja_woman_with_golden_hair_and_amber_eyes_wearing_a_red_and_blue_traditional_japanese_kimono_outfit_with_forehead_mark_and_white_hair_accessory_confident_authoritative_pose_soft_warm_cream_toned_background_clean_flat_color_anime_style_portrait_high_quality&width=420&height=540&seq=naruto-tsunade-2026&orientation=portrait",
    count: 214,
    accent: "secondary",
  },
  {
    id: "sasuke",
    name: "宇智波佐助",
    nameJp: "うちはサスケ",
    title: "复仇忍者 · 天才写轮眼",
    description:
      "背负家族仇恨的宇智波末裔，拥有写轮眼与雷遁忍术。佐助同人围绕复仇与救赎、第七班羁绊展开，冷酷外表下隐藏的孤独与挣扎使其成为极具张力的同人主角。",
    image:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_brooding_teenage_ninja_with_dark_spiky_black_hair_and_intense_dark_eyes_wearing_a_high_collar_dark_blue_and_white_combat_attire_crossed_arms_serious_cool_expression_soft_warm_cream_toned_background_clean_flat_color_anime_style_portrait_high_quality&width=420&height=540&seq=naruto-sasuke-2026&orientation=portrait",
    count: 271,
    accent: "primary",
  },
  {
    id: "naruto",
    name: "漩涡鸣人",
    nameJp: "うずまきナルト",
    title: "七代火影 · 九尾人柱力",
    description:
      "永不言弃的吊车尾，最终成为守护木叶的七代火影。鸣人同人题材广阔，从热血成长、忍道信念到与伙伴的羁绊都备受青睐，是火影同人世界当之无愧的核心人物。",
    image:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_cheerful_energetic_young_ninja_with_spiky_blond_hair_and_blue_eyes_wearing_an_orange_jumpsuit_with_blue_protector_headband_and_facial_whisker_marks_wide_thumbs_up_grin_soft_warm_cream_toned_background_clean_flat_color_anime_style_portrait_high_quality&width=420&height=540&seq=naruto-naruto-2026&orientation=portrait",
    count: 342,
    accent: "secondary",
  },
  {
    id: "kakashi",
    name: "旗木卡卡西",
    nameJp: "はたけカカシ",
    title: "拷贝忍者 · 第七班导师",
    description:
      "神秘而可靠的拷贝忍者，写轮眼与雷切闻名忍界。卡卡西同人既有神秘过往的揭晓，也有带领第七班的温馨日常，成熟稳重的魅力深受读者喜爱。",
    image:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_calm_laid_back_ninja_with_silver_grey_spiky_hair_covered_mostly_by_a_headband_and_a_face_mask_over_lower_face_wearing_dark_green_flak_jacket_leaning_with_book_soft_warm_cream_toned_background_clean_flat_color_anime_style_portrait_high_quality&width=420&height=540&seq=naruto-kakashi-2026&orientation=portrait",
    count: 189,
    accent: "secondary",
  },
  {
    id: "ino",
    name: "山中井野",
    nameJp: "山中いの",
    title: "山中之花 · 感知忍者",
    description:
      "山中一族的活泼少女，精通心转身之术。井野同人常描绘她爽朗自信的性格、与伙伴的日常以及花店老板女儿的身份，带来轻松明快的阅读体验。",
    image:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_cheerful_energetic_ninja_girl_with_blonde_hair_tied_in_a_high_ponytail_and_blue_eyes_wearing_a_purple_sleeveless_top_and_blue_skirt_outfit_confident_pose_soft_warm_cream_toned_background_clean_flat_color_anime_style_portrait_high_quality&width=420&height=540&seq=naruto-ino-2026&orientation=portrait",
    count: 156,
    accent: "primary",
  },
  {
    id: "temari",
    name: "手鞠",
    nameJp: "テマリ",
    title: "风之公主 · 砂隐忍者",
    description:
      "砂隐村风影的长女，手持三星扇的飒爽女忍者。手鞠同人将她的豪爽性格、忍界联姻与家族责任相结合，塑造出独立而迷人的角色形象。",
    image:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_swaggering_ninja_girl_with_long_blonde_hair_and_green_eyes_carrying_a_large_folding_metal_fan_on_her_back_wearing_a_brown_and_black_outfit_bold_confident_smile_soft_warm_cream_toned_background_clean_flat_color_anime_style_portrait_high_quality&width=420&height=540&seq=naruto-temari-2026&orientation=portrait",
    count: 132,
    accent: "accent",
  },
  {
    id: "shizune",
    name: "静音",
    nameJp: "シズネ",
    title: "医疗忍者 · 纲手助手",
    description:
      "纲手身边温婉可靠的医疗忍者，也是五代火影最亲近的助手。静音同人常展现她细心温柔的一面，以及与纲手之间的深厚情谊。",
    image:
      "https://readdy.ai/api/search-image?query=anime_illustration_of_a_gentle_kind_ninja_woman_with_long_dark_brown_hair_in_a_low_ponytail_and_brown_eyes_wearing_a_military_green_jacket_and_skirt_with_pet_brown_pig_on_shoulder_soft_smile_warm_cream_toned_background_clean_flat_color_anime_style_portrait_high_quality&width=420&height=540&seq=naruto-shizune-2026&orientation=portrait",
    count: 98,
    accent: "secondary",
  },
];

export function getCharacter(id: string): Character | undefined {
  return characters.find((c) => c.id === id);
}